import { motion } from "framer-motion";

export const SectionLabel = ({ number, title, light = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className={`flex items-center gap-3 mb-6 md:mb-8 ${
      light ? "text-[#F8F7F3]/50" : "text-[#171717]/45"
    }`}
    data-testid={`section-label-${number}`}
  >
    <span
      className={`h-[1px] w-8 ${light ? "bg-[#F8F7F3]/40" : "bg-[#171717]/30"}`}
    />
    <span className="text-xs md:text-sm font-semibold tracking-[0.18em] uppercase">
      0{number} — {title}
    </span>
  </motion.div>
);
